import { userLogout } from "hfn-auth-legacy/dist/main";

// hfn-auth-legacy builds every endpoint as `${authUrl}/realms/...`, so a trailing
// slash on authUrl produces `//realms/...`. Keycloak used to normalize that away;
// since 26.4 it rejects non-normalized paths outright (CVE-2025-10939) and answers
// {"error":"missingNormalization"}. Strip the trailing slash wherever the config is read.
export const getKeycloakAuthConfig = () => {
  const config = JSON.parse(process.env.REACT_APP_KEYCLOAK_AUTH_CONFIG || "");
  if (typeof config?.authUrl === "string") {
    config.authUrl = config.authUrl.replace(/\/+$/, "");
  }
  return config;
};

const params = getKeycloakAuthConfig();

export const getKeycloakToken = async () => {
    try {
        let refreshToken = null;
        const autInfo = localStorage.getItem("authInfo");
        const autInfoData = autInfo ? JSON.parse(autInfo) : null;
        if (!autInfoData?.srcmToken) return false;
        if (typeof window !== "undefined") {
          const { getRefreshToken } = await import("hfn-auth-legacy/dist/main");
          await getRefreshToken(params)
            .then(async (res) => {
              if (res?.data?.access_token) {
                localStorage.setItem(
                  "authInfo",
                  JSON.stringify({ srcmToken: res?.data?.access_token })
                );
                refreshToken = res?.data?.access_token;
              } else {
                const res = await userLogout(params);
                if (!res?.error) {
                    localStorage.setItem("user", "");
                    window.location.replace("/#/session-expired");
                }
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
        return refreshToken;
    } catch (err) {
        console.log(err);
    }
    return null;
}


export const forceLogout = async () =>{
  localStorage.setItem("user", "");
  window.location.replace("/#/session-expired");
  return true;
}